import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { EnquiryProvider } from "@/context/EnquiryContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import TempoTraveller from "@/pages/TempoTraveller";
import Fleet from "@/pages/Fleet";
import ServiceAreas from "@/pages/ServiceAreas";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import BookingTerms from "@/pages/BookingTerms";
import LocationPage from "@/pages/LocationPage";
import NotFound from "@/pages/NotFound";
import { LOCATIONS } from "@/config/locations";
import { LEGACY_REDIRECTS } from "@/config/legacyRedirects";
import { canonicalPath } from "@/lib/canonicalPath";
import { localizePath } from "@/i18n/locale";

// Both languages use real router paths. Sharing the same page component types
// keeps form state when a visitor switches language on the current page.
const PAGES = [
  ["/", Home],
  ["/services", Services],
  ["/tempo-traveller", TempoTraveller],
  ["/fleet", Fleet],
  ["/service-areas", ServiceAreas],
  ["/about", About],
  ["/contact", Contact],
  ["/booking-terms", BookingTerms],
  ...LOCATIONS.map((location) => [location.slug, LocationPage]),
];

function App({ Router = BrowserRouter, routerProps = {}, renderedYear }) {
  return (
    <div className="App">
      <Router {...routerProps}>
        <LanguageProvider>
          <EnquiryProvider>
            <Toaster richColors position="top-center" />
            <Routes>
              {/* Legacy WordPress paths -> client-side redirect (SPA navigation fallback;
                  direct hits are also served a prerendered meta-refresh stub). */}
              {["en", "hi"].flatMap((locale) => LEGACY_REDIRECTS.map((r) => (
                <Route key={`${locale}:${r.from}`} path={localizePath(r.from, locale)} element={<Navigate to={localizePath(canonicalPath(r.to), locale)} replace />} />
              )))}
              <Route element={<Layout renderedYear={renderedYear} />}>
                {["en", "hi"].flatMap((locale) => PAGES.map(([path, Page]) => (
                  <Route key={`${locale}:${path}`} path={localizePath(path, locale)} element={<Page />} />
                )))}
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </EnquiryProvider>
        </LanguageProvider>
      </Router>
    </div>
  );
}

export default App;
